import React from "react";
import { CSidebarBrand } from "@coreui/react";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/images/LogoImage.jpg";
import ROUTE_NAMES from "../../routes/routeNames";

const NavbarLogo = () => {
  return (
    <CSidebarBrand
      as={NavLink}
      to={ROUTE_NAMES.MAIN_ROUTES.DASHBOARD}
      className="text-decoration-none logo-wrapper"
    >
      <div className="logo-container">
        <img
          src={Logo}
          alt="DiveBuddies"
          className="logo-img"
          draggable={false}
        />
      </div>
    </CSidebarBrand>
  );
};

export default React.memo(NavbarLogo);
